<template>
    <div>
        <Head title="Новий шаблон смс"/>
        <h1 class="mb-8 text-3xl font-bold">
            <Link
                class="text-indigo-400 hover:text-indigo-600"
                :href="$route('messages.index')"
            >
                Шаблони смс
            </Link>
            <span class="text-indigo-400 font-medium">/</span> Створити
        </h1>
        <div class="max-w-3xl bg-white rounded-md shadow overflow-hidden">
            <form @submit.prevent="store" enctype="multipart/form-data">
                <div class="flex flex-wrap -mb-8 -mr-6 p-8">
                    <select-input v-model="form.lake_id" :error="form.errors.lake_id" class="pb-8 pr-6 w-full lg:w-1/2"
                                  label="Озеро">
                        <option :value="null"/>
                        <option v-for="lake in lakes" :key="lake.id" :value="lake.id">{{ lake.name }}</option>
                    </select-input>
                    <textarea-input v-model="form.text" :error="form.errors.text"
                    class="pb-8 pr-6 w-full" label="Текст смс"/>
                    <div class="pb-4 w-full">
                        <p>Натисніть щоб вставити в шаблон:</p>
                    </div>
                    <div v-for="(label, placeholder) in pastedPlaceholders" :key="placeholder" class="w-1/2 p-1">
                        <button
                            type="button"
                            class="cursor-pointer text-blue-500 bg-gray-100 hover:bg-gray-200 rounded-md px-2 py-1 w-full"
                            @click.prevent="pasteText(placeholder)"
                        >
                            {{ label }}
                        </button>
                    </div>
                </div>
                <div class="flex items-center justify-end px-8 py-4 bg-gray-50 border-t border-gray-100">
                    <loading-button :loading="form.processing" class="btn-indigo" type="submit">
                        Створити новий шаблон
                    </loading-button>
                </div>
            </form>
        </div>
    </div>
</template>

<script>
import {Head, Link} from '@inertiajs/inertia-vue3'
import Layout from '@/Shared/Layout'
import TextInput from '@/Shared/TextInput'
import SelectInput from '@/Shared/SelectInput'
import LoadingButton from '@/Shared/LoadingButton'
import TextareaInput from '@/Shared/TextareaInput'

export default {
    components: {
        TextareaInput,
        Head,
        Link,
        LoadingButton,
        SelectInput,
        TextInput,
    },
    layout: Layout,
    props: {
        lakes: Array,
    },
    remember: 'form',
    data() {
        return {
            form: this.$inertia.form({
                text: '',
                lake_id: null,
            }),
            pastedPlaceholders: {
                '{lake_name}': 'Назва озера',
                '{order_number}': 'Номер заказу',
                '{order_date}': 'Дата рибалки',
                '{order_name}': 'Ім\'я клієнта',
                '{order_sum}': 'Сума заказу',
                '{order_quantity}': 'Кількість людей',
                '{fishing_type}': 'Тип рибалки',
                '{category_type}': 'Тариф',
                '{order_point}': 'Місце рибалки',
                '{bonus_awarded}': 'Нараховані бонуси (грн)',
            }
        }
    },
    methods: {
        store() {
            this.form.post(this.$route('messages.index'))
        },
        pasteText(text) {
            this.form.text += text;
        },
    },
}
</script>

